import { atom } from "jotai";

// timezoneAtom holds the IANA time-zone name used to render user-facing
// timestamps (worker run times, certificate issue dates, event times). It is a
// client-persisted preference (Phase 1, no backend column yet) — the same shape
// as localeAtom: a localStorage-backed source-of-truth atom (manifest §1).
//
// Why a stored preference at all: a timestamp is a wall-clock fact only once you
// fix a zone. The browser's resolved zone is a sane default, but a user who
// travels, observes a galaxy in another region, or simply prefers a fixed zone
// needs to override it. Note: this only shifts *instant* timestamps. Observation
// PERIOD labels (e.g. 2024-Q1(Jan) month buckets) are UTC-anchored deterministic
// labels (W-02) and must NOT be shifted by this — see lib/datetime.ts.

// resolvedTimezone reads the browser's current zone, guarding the rare case
// where Intl can't resolve one (very old runtimes) so we never persist "".
function resolvedTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

const stored = localStorage.getItem("ace-timezone");

export const timezoneAtom = atom<string>(stored || resolvedTimezone());

export const setTimezoneAction = atom(null, (_get, set, tz: string) => {
  const next = tz || resolvedTimezone();
  set(timezoneAtom, next);
  localStorage.setItem("ace-timezone", next);
});
